import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Drawer/drawer';
import { css } from '@patternfly/react-styles';
import { DrawerContext } from './Drawer';
import { formatBreakpointMods } from '../../helpers/util';
export var DrawerPanelContent = function DrawerPanelContent(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      children = _a.children,
      _a$hasNoBorder = _a.hasNoBorder,
      hasNoBorder = _a$hasNoBorder === void 0 ? false : _a$hasNoBorder,
      widths = _a.widths,
      props = __rest(_a, ["className", "children", "hasNoBorder", "widths"]);

  return React.createElement(DrawerContext.Consumer, null, function (_ref) {
    var isExpanded = _ref.isExpanded,
        isStatic = _ref.isStatic;
    return React.createElement("div", Object.assign({
      className: css(styles.drawerPanel, hasNoBorder && styles.modifiers.noBorder, formatBreakpointMods(widths, styles), className),
      hidden: isStatic ? false : !isExpanded
    }, props), children);
  });
};